import MoreCoreUiControl from '../_ControlBase/_ControlBase';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './Button.html?raw';
import docu from './ButtonDocumentation.html?raw';
import { ColorHelpers, HtmlHelpers, TranslationHelpers } from "../../../more/Helpers";
import _Container from 'dijit/_Container';
import _WidgetBase from 'dijit/_WidgetBase';
import methodHooks from 'more/mdsMethodHooks';
class Button extends methodHooks(compose(MoreCoreUiControl, _Container)) {
    templateString: any = template;


    protected buttonNode: HTMLElement;
    protected labelStack: HTMLSpanElement;
    protected button_IconLeftContainer: HTMLSpanElement;
    protected button_LabelContainer: HTMLSpanElement;
    protected button_SecondaryLabelContainer: HTMLSpanElement;
    protected button_IconRightContainer: HTMLSpanElement;

    protected _value: string; // Note: In a form, the button and its value is only submitted if the button itself was used to submit the form.

    protected _label: string;
    protected iconLeft: string;
    protected iconRight: string;
    private _minDefaultClasses: string = "buttonBase moreCoreButton";
    private defaultClassnames: string = ""; // defaultBtn führt dazu, dass die Klasse auch oft unerwünscht dabei ist. ist jetzt im Startup als Fallback...
    private enabledClassnames: string = "";
    private disabledClassnames: string = "w3-disabled";
    isReadonly: boolean = false;
    private _isVisible: boolean = true;
    private _isIconVisible: boolean = false;
    private _iconOnly: boolean = false;

    onClick: Function;

    focus() {
        this.buttonNode.focus();
    }

    // Events

    _onClick_Button(evt: MouseEvent): void {
        if (this.isReadonly === true) return;
        this.emit("buttonClicked", evt);
        this.emit("click", evt);

        if (this.onClick) this.onClick(evt);
    }

    setClick(fct: Function) {
        this.onClick = fct;
    }

    private _onHover_Button(evt: MouseEvent): void {

    }

    private _onMouseOut_Button(evt: MouseEvent): void {

    }

    private _onMouseDown_Button(evt: MouseEvent): void {
        
    }

    private _onMouseUp_Button(evt: MouseEvent): void {
        
    }
    private _setEnabledClassesAttr(classnames: string) {
        this.setClassesEx({ enabledClasses: classnames });
    }
    private _setDisabledClassesAttr(classnames: string) {
        this.setClassesEx({ disabledClasses: classnames });
    }
    private _setDefaultClassesAttr(classnames: string) {
        this.setClassesEx({ defaultClasses: classnames });
    }
    private _setDisabledAttr(readonly: boolean) {
        this.setReadonly(readonly);
    }
    private _setReadonlyAttr(readonly: boolean) {
        this.setReadonly(readonly);
    }
    // Contents

    setup(config: {
        styleClass?: string,
        parentNode?: HTMLElement,
        enabledClasses?: string, 
        disabledClasses?: string,
        iconLeft?: string,
        iconRight?: string,
        iconClass?: string,
        label?: string,
        tooltip?: string,
        secondaryLabel?: string,
        callback: (evt: MouseEvent) => any
    }, placeAt?: HTMLElement, position?: "first" | "last" | "only" | number) {

        // Hinweis: noch ganz rudimentär. da geht noch mehr Logik, auch mit resetten von Werten und Icons mit null anstelle von undefined etc...

        if (config.label) this.setLabel(config.label, config.secondaryLabel);
        if (config.parentNode) this.placeAt(config.parentNode);
        if (config.styleClass) {
            this.UiModder.domClass.remove(this.buttonNode); // alles raus
            this.UiModder.domClass.add(this.buttonNode, config.styleClass); // das rein
            this.UiModder.domClass.add(this.buttonNode, "buttonBase"); // IMMER mit rein
            this.defaultClassnames = this.buttonNode.className; // aktuelles Ergebnis als default hinterlegen
        }
        if (config.enabledClasses || config.disabledClasses) {
            this.setClasses(config.enabledClasses, config.disabledClasses);
        }
        // mindest-Klassen wieder einfügen!
        if (this._minDefaultClasses) this.UiModder.domClass.add(this.buttonNode, this._minDefaultClasses);

        if (config.iconClass) this._setIconAttr(config.iconClass);
        if (config.iconLeft) this.setIconLeft(config.iconLeft);
        if (config.iconRight) this.setIconRight(config.iconRight);
        if (config.callback) this.setClick(config.callback);
        if (config.tooltip) this.domNode.title = config.tooltip;

        if (placeAt) {
            this.placeAt(placeAt, position);
        }
    }

    private _secondaryLabel: string;
    setLabel(newValue: string, secondaryLabel?: string, tooltip?: string): void {
        if (newValue != undefined) {
            if (newValue) {
                newValue = TranslationHelpers.tryTranslate(newValue);
            }

            this._label = newValue;
        }
        this.button_LabelContainer.textContent = this._label ? this._label : "";
        this.hideNode(this.button_LabelContainer, !this._label);
        

        if (typeof (secondaryLabel) != "undefined") {
            this._secondaryLabel = secondaryLabel ? TranslationHelpers.tryTranslate(secondaryLabel) : "";
            this.hideNode(this.button_SecondaryLabelContainer, !secondaryLabel);
            this.button_SecondaryLabelContainer.textContent = this._secondaryLabel;
        }

        if (typeof (tooltip) == "string") this.domNode.title = tooltip;

        this.hideNode(this.labelStack, !this._label && !this._secondaryLabel);
    }

    setColorationFromProperty(color: more.EntityAPIColor, component?: "BG" | "TXT") {
        let hexColorBG = ColorHelpers.getHexColorFromProperty(color, "BG");
        let hexColorTXT = ColorHelpers.getHexColorFromProperty(color, "TXT");

        if (component == "BG") {
            this.setColor(hexColorBG, null);
            return;
        }

        if (component == "TXT") {
            this.setColor(null, hexColorTXT);
            return;
        }

        this.setColor(hexColorBG, hexColorTXT);
    }

    setColor(colorBG: string, colorTXT: string) {
        let hexColorBG = ColorHelpers.getHexColorFromString(colorBG);
        let hexColorTXT = ColorHelpers.getHexColorFromString(colorTXT);

        this.domNode.style.removeProperty("--bgColor");
        this.domNode.style.removeProperty("--txtColor");

        this.UiModder.domClass.remove(this.domNode, "customColor _darkBGcolor");

        if (hexColorBG) {
            this.domNode.style.setProperty("--bgColor", hexColorBG);

            this.UiModder.domClass.add(this.domNode, "customColor");

        }

        if (!hexColorTXT) {
            if (hexColorBG && ColorHelpers.isDarkColor(hexColorBG)) {
                this.UiModder.domClass.add(this.domNode, "_darkBGcolor");
            }
        }
        else {
            this.domNode.style.setProperty("--txtColor", hexColorTXT);

            this.UiModder.domClass.add(this.domNode, "customColor");
        }
    }

    setClasses(enabledClasses: string, disabledClasses?: string, defaultClasses?: string) {
        this.setClassesEx({
            enabledClasses: enabledClasses,
            disabledClasses: disabledClasses,
            defaultClasses: defaultClasses
        });
    }
    setClassesEx(config: {
        enabledClasses?: string,
        disabledClasses?: string,
        defaultClasses?: string
    } | string, removeClasses?: string) {
        let bChange = false;

        if (!this._isRendered) {
            // man müsste das hier verzögern und rückhalten bis es wirklich im postcreate oder startup war
            // weil hierher kommen wir auch, wenn über dojo-props Klassen eingeschleust worden sind
            // dann liest das buildrendering aber diese Klassen aus und interpretiert da einiges falsch etc.
            // ein Schlamassel. LG xoxo
        }

        if (config && typeof (config) == "object") {

            if (config.enabledClasses != undefined && config.enabledClasses != this.enabledClassnames) {
                bChange = true;
                if (this.enabledClassnames) this.UiModder.domClass.remove(this.buttonNode, this.enabledClassnames);
                this.enabledClassnames = config.enabledClasses;
            }

            if (config.disabledClasses != undefined && this.disabledClassnames != config.disabledClasses) {
                bChange = true;
                if (this.disabledClassnames) this.UiModder.domClass.remove(this.buttonNode, this.disabledClassnames);
                this.disabledClassnames = config.disabledClasses;
            }

            if (config.defaultClasses != undefined && this.defaultClassnames != config.defaultClasses) {
                bChange = true;
                if (this.defaultClassnames) this.UiModder.domClass.remove(this.buttonNode, this.defaultClassnames);
                this.defaultClassnames = config.defaultClasses;
            }
        } else if (typeof (config) == "string") {
            // die Klasse kommt einfach dazu
            this.UiModder.domClass.add(this.domNode, config);
        }

        if (removeClasses) {
            this.UiModder.domClass.remove(this.domNode, removeClasses);
        }

        if (bChange) this._setReadonlyStyle();
    }

    getLabel(): string {
        return this._label;
    }
    setIcon(iconClass: string, secondaryIconRight?: string) {
        this.setIconLeft(iconClass);
        if (secondaryIconRight) this.setIconRight(secondaryIconRight);
    }
    setIconLeft(iconClass: string): void {
        this.iconLeft = iconClass;
        if (this.iconLeft) {
            HtmlHelpers.createFontawesomeIcon(this.iconLeft, null, this.button_IconLeftContainer, "only");
        } else {
            this.UiModder.domConstruct.empty(this.button_IconLeftContainer);
        }
        this.hideNode(this.button_IconLeftContainer, !this.iconLeft);
    }

    getIconLeft(): string {
        return this.iconLeft;
    }

    setIconRight(iconClass: string): void {
        this.iconRight = iconClass;
        if (this.iconRight) {
            HtmlHelpers.createFontawesomeIcon(this.iconRight, null, this.button_IconRightContainer, "only");
        } else {
            this.UiModder.domConstruct.empty(this.button_IconRightContainer);
        }
        this.hideNode(this.button_IconRightContainer, !this.iconRight);
    }

    getIconRight(): string {
        return this.iconRight;
    }

    //setReadonlyStylesXXX(enabledClasses: string, disabledClasses: string) {
    //    if (typeof (enabledClasses) != "undefined") {
    //    }
    //    if (typeof (disabledClasses) != "undefined") {
    //        if (this.disabledClassnames) this.UiModder.domClass.remove(this.buttonNode, this.disabledClassnames);
    //        this.disabledClassnames = disabledClasses;
    //    }

    //    this._setReadonlyStyle();
    //}

    // Styles

    pressEffect(): void {

        
    }

    hide(bHide?: boolean): void {
        if (bHide === false) {
            this.show();
            return;
        }
        this._isVisible = false;
        this.hideNode(this.domNode);
    }

    show(bShow?: boolean): void {
        if (bShow === false) {
            this.hide();
            return;
        }
        this._isVisible = true;
        this.hideNode(this.domNode, false);
    }

    private _setVisibleAttr(bVisible: boolean) {
        if (bVisible === false) {
            this.hide();
        } else {
            this.show();
        }
    }

    isVisible(): boolean {
        return this._isVisible
    }

    setReadonly(bReadOnly: boolean): void {
        this.isReadonly = bReadOnly;
        this._setReadonlyStyle();
    }

    protected _setReadonlyStyle(): void {
        this.UiModder.domAttr.set(this.buttonNode, "disabled", this.isReadonly)
        if (this.enabledClassnames) this.UiModder.domClass.toggle(this.buttonNode, this.enabledClassnames, this.isReadonly !== true);
        if (this.disabledClassnames) this.UiModder.domClass.toggle(this.buttonNode, this.disabledClassnames, this.isReadonly === true);
        if (this.defaultClassnames) this.UiModder.domClass.add(this.buttonNode, this.defaultClassnames);
        if (this._minDefaultClasses) this.UiModder.domClass.add(this.buttonNode, this._minDefaultClasses);
    }

    private _setIconRight(iconstring: string) {
        this.setIconRight(iconstring);
    }
    private _setIconAttr(iconstring: string) {
        this.setIconLeft(iconstring);
    }
    private _setIconLeftAttr(iconstring: string) {
        this.setIconLeft(iconstring);
    }

    getIconOnly(): boolean {
        return this._iconOnly;
    }

    // Doku
    getDocumentationContent(): string {
        return docu;
    }

    // dojo-Setter und Getter
    private _setLabelAttr(newValue: string): void {
        this.setLabel(newValue);
    }

    private _setSecondaryLabelAttr(value: string) {
        this.setLabel(this._label, value);
    }

    /**
    * Achtung: Vererbung von dojo-Container. Diese Methode nicht von außerhalb programmatisch nutzen.
    * @param element
    * @returns
    */
    private _addChildElement(element: MdsLax<InstanceType<typeof _WidgetBase>> | HTMLElement): void {
        // dojo-Funktion aus _Container: umleiten!
        if (!element) return;

        if (typeof (element) == "object") {
            if (element["nodeType"] == 3) // text
            {
                let node = element as HTMLElement;
                let content = node.textContent.trim();

                if (!content) return;

                //this.button_LabelContainer.innerHTML = node.textContent;
                //this.UiModder.domConstruct.place(node, this.button_LabelContainer);
                if (this._label?.length > 2) {
                    this.setLabel(this._label, content);
                } else {
                    this.setLabel(content);
                }

                return;
            }
        }

        if (element instanceof _WidgetBase) {
            try {
                element.placeAt(this.button_LabelContainer);
            } catch (ex) {
                console.warn(this.id + " addChild failed: " + ex, this, element);
            }
        } else if (element instanceof HTMLElement) {
            try {
                // prüfen ob es ein Icon ist und dieses gleich korrekt setzen
                if (element.nodeName.toUpperCase() == "I" &&
                     (element.classList.contains("fas") ||
                        element.classList.contains("far") ||
                        element.classList.contains("fa-solid") ||
                        element.classList.contains("fa-regular") ||
                        element.classList.contains("fa")
                    )) {
                    // falls schon ein Label drin ist und ein Icon dann noch daherkommt, nehmen wir an es soll rechts vom Text erscheinen:
                    if (this._label?.length > 1 || !!this.iconLeft) {
                        this.setIconRight(element.className);
                    } else {
                        this.setIconLeft(element.className);
                    }
                    this.UiModder.domConstruct.destroy(element);
                    return;

                }
                else if (element.nodeName.toUpperCase() == "SPAN") {
                    let content = element.innerText;
                    if (content) {
                        if (this._label?.length > 2) {
                            this.setLabel(this._label, content);
                        } else {
                            this.setLabel(content);
                        }
                    }

                    return;
                }
            }
            catch (ex) {

            }
            this.UiModder.domConstruct.place(element, this.button_LabelContainer);
        }
    }

    private _originalID: string;
    private _isRendered: boolean = false;
    buildRendering(): void {
        super.buildRendering.apply(this, arguments as any);
        this._originalID = this.domNode.id;

        // einmal ausm eigenen Layout rausparsen was die Standardklassen sein sollen BEVOR es weitere Klassen aus dem Parent erhält:        
        let classnames = this.domNode.className;
        if (classnames) {
            this._minDefaultClasses = classnames;
            this.UiModder.domClass.remove(this.domNode, this._minDefaultClasses);
        }
        this._isRendered = true;
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        // falls der Button über das disabled-Flag deaktiviert worden ist:
        if (this.domNode.attributes.getNamedItem("disabled")) {
            this.isReadonly = true;
        }

        // falls der Button im template readonly gesetzt wurde, kommt zwischen buildrendering und postCreate das setReadonlyStyles
        // das verfälscht uns die Classnames, weil wir natürlich nicht für immer die w3-disabled etc drin haben wollen!
        if (this.isReadonly) {
            this.isReadonly = false;
            this._setReadonlyStyle();
            this.isReadonly = true; // style wird am Ende nochmal gesetzt
        }

        // im buildrendering haben wir die Klassen aus dem eigenen Template rausgelesen. jetzt lesen ob noch was dazugekommen sit:
        let bWasInvisible = false;
        if (!this._isVisible) {            
            this.hideNode(this.domNode, false);
        }
        let classnames = this.domNode.className;
        if (classnames) {
            // trotzdem hidenode rückgängig machen um sicherzugehn
            this.hideNode(this.domNode, false);
            let newClassnames = this.domNode.className;

            this._setDefaultClassesAttr(newClassnames); // ersetzen was sonst oben scho als default definiert ist

            if (classnames != newClassnames) {
                // da war irgendwas drin versteckt was die Node gehidden hat
                this.hide();
            }
        }


        if (this.containerNode.firstChild) {
            let count = 0;
            let index = 0;
            let previousElement = null;
            let currentElement = null;
            // achtung, childnodes wird durch addChild direkt manipuliert, d.h. mit jedem durchlauf kürzer.
            while (this.containerNode.childNodes.length > 0) {
                currentElement = this.containerNode.childNodes[index];
                if (currentElement == undefined) return;
                if (previousElement == currentElement) {
                    // wenn was im vorherigen Durchlauf nicht mit addchild weggeplaced worden ist, dann hier erkannt und index erhöhen.
                    index++;
                }
                else {
                    this._addChildElement(currentElement as HTMLElement);
                    previousElement = currentElement;
                }
                count++;

                if (index == this.containerNode.childNodes.length) break;

                if (count == 999) break; // notfall-exit
            }
        }
        this._setReadonlyStyle();
    }
    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);

       
    }
    public setAllDataCyAttributes() {
        this.setDataCyAttribute(this.buttonNode, "");
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        if (!this.defaultClassnames) {
            this.defaultClassnames = "defaultBtn";
        }

        this._setReadonlyStyle();

        if (!this._isVisible) this.hide();
    }
}

export default mdsWidget(Button);